/*  The final status of an encounter, as R2 asks for it.

    An encounter with a danger sign alert ends in one of two ways: the worker stopped it, or the
    worker acknowledged the alert and carried on to the end. An encounter with no danger sign at
    all was never in scope, so it carries no status and its document stays exactly as it is. */
export const STOPPED_AFTER_DANGER_SIGN = 'stopped_after_danger_sign';
export const COMPLETED = 'completed';

export type EncounterStatus = typeof COMPLETED | typeof STOPPED_AFTER_DANGER_SIGN;

export interface EncounterOutcomeFacts {
  stopped: boolean;
  dangerSignFound: boolean;
}

/*  No danger sign in this encounter means the encounter was never in scope for R2, so it carries
    no status at all and its document stays exactly as it is today. */
export function encounterStatusFor({
  stopped,
  dangerSignFound,
}: EncounterOutcomeFacts): EncounterStatus | undefined {
  if (stopped) return STOPPED_AFTER_DANGER_SIGN;
  if (dangerSignFound) return COMPLETED;
  return undefined;
}
